import {
  Button,
  PlusIcon,
  Tooltip,
  TooltipContent,
  Typography,
} from "@codat/orchard-ui";
import React, { FC, useState } from "react";

import styles from "./CreateApiKeyButton.module.css";

export const CreateApiKeyButton: FC<{
  onClick: () => void;
  isLimit: boolean;
  isLoading: boolean;
}> = ({ onClick, isLimit, isLoading }) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const handleOpenTooltip = () => {
    if (isLimit) {
      setShowTooltip(true);
    }
  };
  const handleCloseTooltip = () => {
    setShowTooltip(false);
  };

  return (
    <div
      onFocus={handleOpenTooltip}
      onMouseEnter={handleOpenTooltip}
      onMouseLeave={handleCloseTooltip}
      onBlur={handleCloseTooltip}
    >
      <Tooltip
        isOpen={showTooltip}
        placement="top"
        content={
          <TooltipContent>
            <Typography
              variant="body_md"
              as="div"
              className={styles.typoContainer}
            >
              <p className={styles.bold}>API key limit reached</p>
              <p>You can have up to 10 API keys</p>
            </Typography>
          </TooltipContent>
        }
      >
        <Button
          data-testid="create-api-key-button"
          className={styles.leftMargin}
          color="action"
          variant="primary"
          onClick={onClick}
          disabled={isLimit || isLoading}
        >
          <PlusIcon className={styles.plus} />
          Create another API key
        </Button>
      </Tooltip>
    </div>
  );
};
